import {AssignmentPerType} from '../models/assignments'

export interface GroupBasic {
  groupe_ad_id: number
  nom: string
}
export class Group {
  public groupe_ad_id: number
  public groupe_dn: string
  public nom: string
  public etablissement_specifique: boolean
  public source: string
  public gal: boolean
  public description: string
  public courriel: string
  public commentaire: string
  public assignments?: AssignmentPerType

  constructor(
    groupe_ad_id: number,
    groupe_dn: string,
    nom: string,
    etablissement_specifique: boolean,
    source: string,
    gal: boolean,
    description: string,
    courriel: string,
    commentaire: string,
  ) {
    this.groupe_ad_id = groupe_ad_id
    this.groupe_dn = groupe_dn
    this.nom = nom
    this.etablissement_specifique = etablissement_specifique
    this.source = source
    this.gal = gal
    this.description = description
    this.courriel = courriel
    this.commentaire = commentaire
    this.assignments = new AssignmentPerType()
  }
}

export interface GroupStatus {
  ad_groupe_ad_etat_ad_id: number,
  etablissement_id: number,
  groupe_ad_id: number,
  etat_ad: string,
  source: string,
  etat_refedu: string,
  is_in_ad: boolean
}

export interface GroupDetails {
  assignments: AssignmentPerType
  groupsStatus: GroupStatus[]
}

export interface LdapTreeNode {
  id: number
  name: string
  dn: string
  children: LdapTreeNode[]
}
